<template>
  <a-layout id="components-layout-demo-top-side">
    <a-layout-header class="header">
      <div class="logo float-left">
        <img :src="require('./logo_text.png')" class="logo-pic" />
      </div>
      <!--div class="title float-left ml-4">
      </div-->
      <a-popover v-model="visible" trigger="click" placement="bottomRight">
        <div slot="content" class="accountInfo">
          <a-avatar class="avatar accountInfoAvatar" :size="60">
            {{initials}}
          </a-avatar>
          <div class="account text-center"><span>{{info.name || ''}}</span><a-tag color="orange" class="account-tag ml-2" v-if="isAgent">渠道用户</a-tag></div>
          <div class="loginTime text-center">上一次登录：{{$moment(info.last_active_at).fromNow()}}</div>
          <div class="accountBtn text-center" v-if="level"><a href="/">云管控制台</a></div>
          <div class="accountBtn text-center"><a href="/account" target="_blank">账户中心</a></div>
          <!-- <div class="accountBtn text-center" v-if="isAgent"><a href="javascript:void(0)" @click="handleViewClick('/reportProject')">渠道报备</a></div> -->
          <a-button icon="export" class="logout" @click="logout">退出</a-button>
        </div>
        <div class="userName float-right">
          <a-avatar class="avatar" style="margin-top: 0px" :size="30">
            {{initials}}
          </a-avatar>
          {{info.mobile || info.name}}<a-icon class="ml-1" type="caret-down" />
        </div>
      </a-popover>
      <!-- <div class="float-right mr-4">
        <a-button type="primary" class="download-btn align-self-center" @click="goDownloadPage">
          下载试用
        </a-button>
      </div> -->
      <!-- <a-menu
        class="header-menu mr-2"
        theme="light"
        mode="horizontal"
        :style="{ lineHeight: '60px', border: 0 }">
        <a-menu-item>
          <a :href="path">官网<a-icon type="select" class="ml-2" /></a>
        </a-menu-item>
      </a-menu> -->
    </a-layout-header>
  </a-layout>
</template>

<script>
import * as R from 'ramda'
import { mapState, mapGetters } from 'vuex'
import Cookies from 'js-cookie'
// import { OW_PATHS } from '../../constants/config'

export default {
  name: 'AccountNavbar',
  data () {
    return {
      visible: false,
      path: 'https://' + window.location.host,
    }
  },
  computed: {
    ...mapGetters([
      'logo',
    ]),
    ...mapState('auth', {
      info: state => state.info || {},
    }),
    ...mapState('app', {
      level: state => state.customerCapability.customer_level,
      isAgent: state => state.customerCapability.is_agent,
    }),
    initials () {
      if (this.info.name) {
        return this.info.name.substr(0, 1).toUpperCase()
      }
      return ''
    },
  },
  async created () {
    const data = await this.$store.dispatch('app/getCustomerCapabilities')
    if (!R.isNil(data.customer_id)) {
      await this.$store.dispatch('app/getEnterPriseInfo')
    } else {
      this.$router.push('/no-customer')
    }
    this.$store.dispatch('app/getCities')
  },
  methods: {
    goDownloadPage () {
      window.location.href = this.path + '/download/index.html'
    },
    handleViewClick (target) {
      if (this.$route.fullPath === target) return
      this.$router.push(target)
    },
    logout () {
      Cookies.remove('yunionauth', {
        domain: '.yunion.cn',
      })
      Cookies.remove('yunionauth', {
        domain: '.yunion.io',
      })
      window.location.href = this.path
    },
  },
}
</script>

<style lang="scss" scoped>
#components-layout-demo-top-side .header {
  color: #606266;
  height: 64px;
  box-shadow: 0 2px 4px 0 hsla(0,0%,93%,.5), 0 2px 4px 0 hsla(0,0%,93%,.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #fff;
}
.logo-pic {
  height: 40px;
}
.title {
  font-size: 21px;
  font-weight: 500;
  line-height: 64px;
}
.header-menu {
  float: right;
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
}
.avatar {
  color: #fff;
  background-color: rgb(26, 122, 224);
  margin-top: 16px;
  cursor: pointer;
  position: relative;
}
.accountInfo {
  width: 200px;
  .accountInfoAvatar {
    display: block;
    margin: 10px auto;
    font-size: 35px !important;
  }
  .account {
    position: relative;
    font-size: 18px;
    font-weight: 400;
    color: #5f6368;
    margin-bottom: 16px;
    .account-tag {
      position: absolute;
      line-height: 22px;
      border-radius: 5px;
    }
  }
  .logout {
    display: block;
    margin: 20px auto;
  }
  .loginTime {
    font-size: 14px;
    color: #323F52;
    margin-bottom: 25px;
  }
  .accountBtn {
    height: 38px;
    line-height: 38px;
    border-top: 1px solid rgba(0,0,0,.2);
    cursor: pointer;
    &:last-of-type {
      border-bottom: 1px solid rgba(0,0,0,.2);
    }
    &:hover {
      border-top: 1px solid #333;
      border-bottom: 1px solid #333;
    }
    a {
      color: rgba(0,0,0,.8);
    }
  }
}
.userName {
  font-size: 16px;
  line-height: 62px;
  color: #0A1F44;
  cursor: pointer;
  &:hover {
    color: #1890ff;
  }
}
.userAvatar {
  font-size: 16px;
  line-height: 62px;
}
.download-btn {
  background-color: #1678ff;
  border-radius: 5px;
}
.dashboard {
  color: #0A1F44;
}
</style>
